/* LUNA cart adapter — D29/D38.
   One place that knows how to add to cart and reveal it, so sections never talk to the theme directly.
   Adapter order:
   1. Rebuy Smart Cart (the store's real cart drawer; loaded via snippets/rebuy-extensions.liquid,
      which theme.claude.liquid renders explicitly — it is a theme install, not an app embed)
   2. Flex's window.PXUTheme.jsAjaxCart (drawer or mini-cart mode, feature-detected)
   3. cart:refresh events, then counts-only */
(function(){
  if(window.lunaCart) return;

  function rebuy(){
    return (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function')
      ? window.Rebuy.SmartCart : null;
  }
  function pxu(){
    return (window.PXUTheme && window.PXUTheme.jsAjaxCart) ? window.PXUTheme.jsAjaxCart : null;
  }

  function refreshCounts(cart){
    // our own header
    document.querySelectorAll('[data-luna-cart-count]').forEach(function(el){
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    // Flex's header bindings, so the two never disagree
    document.querySelectorAll('[data-bind="itemCount"]').forEach(function(el){
      el.textContent = cart.item_count;
    });
    document.querySelectorAll('[data-ajax-cart-trigger]').forEach(function(el){
      el.classList.toggle('has-cart-count', cart.item_count > 0);
    });
  }

  function reveal(){
    var sc = rebuy();
    if(sc){
      try{ sc.show(); return 'drawer'; }catch(e){ /* fall through */ }
    }
    var api = pxu();
    if(api){
      try{
        if(typeof api.updateView === 'function') api.updateView();
        // showDrawer returns false when cart_action is not 'drawer'
        if(typeof api.showDrawer === 'function' && api.showDrawer() !== false) return 'drawer';
        // mini-cart mode: Flex reveals by class on the trigger
        var trig = document.querySelector('[data-ajax-cart-trigger]');
        if(trig){ trig.classList.add('show-mini-cart'); return 'mini'; }
      }catch(e){ /* fall through */ }
    }
    // themes that listen for their own refresh events
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
    document.dispatchEvent(new CustomEvent('cart:build'));
    return 'none';
  }

  function add(items){
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r){
      return r.json().then(function(data){
        if(!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    })
    .then(function(){
      return fetch('/cart.js', { headers:{ 'Accept':'application/json' } }).then(function(r){ return r.json(); });
    })
    .then(function(cart){
      refreshCounts(cart);
      var how = reveal();
      document.dispatchEvent(new CustomEvent('luna:added', { detail:{ cart: cart, revealed: how } }));
      return cart;
    });
  }

  /* keep our badge honest when the cart changes INSIDE Smart Cart (qty edits, removals).
     Rebuy dispatches document events; exact names verified at runtime — we listen broadly
     and re-read /cart.js, which is cheap and always correct. */
  var syncTimer = null;
  function syncSoon(){
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function(){
      fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
        .then(function(r){ return r.json(); })
        .then(refreshCounts)
        .catch(function(){});
    }, 350);
  }
  ['rebuy:cart.change','rebuy:cart.add','rebuy:cart.remove','rebuy:smartcart.change','cart:refresh']
    .forEach(function(ev){ document.addEventListener(ev, syncSoon); });

  window.lunaCart = { add: add, reveal: reveal, refreshCounts: refreshCounts };
})();